import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';
function RegulatorySupportServices() {

  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Regulatory Support Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-4">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Regulatory Support Services
          </h3>
        </div>

        {/* <h4 className="text-md font-bold text-[#05326D] mb-4">
          Regulatory Support Services
        </h4> */}

        <p className="mb-4 text-[#05326D] mb-8">
          <span className="text-md font-bold text-[#05326D] mb-4">Comprehensive Solutions for Global Submission Excellence
          </span>
          At FDAC Consultancy, we offer a wide spectrum of specialized regulatory support services designed to streamline your submission process and
          ensure compliance with international health authority standards. Whether you’re preparing dossiers, conducting clinical studies, or managing
          pharmacovigilance activities, our expert team is equipped to guide you through every step with precision and agility.
        </p>

        <hr className="border-t border-gray-300 mb-8" />


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Dossier & Technical Documentation
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Dossier Due Diligence: Thorough review and gap analysis for regulatory readiness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Writing: Authoring of CTD Modules (Clinical Overview & Non-Clinical Overview)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Genotoxicity Assessments: API and impurity evaluations using validated software tools such as MultiCase</p>
        <p className="ml-2 mt-2 text-[#05326D]">Environmental Risk Assessment (ERA): Report preparation aligned with EMA’s September 2024 guidelines</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Clinical & Non-Clinical Services
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Module 2.4–2.7 Report Writing: Clinical and non-clinical overviews and summaries for EU and RoW submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Study Oversight: Auditing and monitoring of Phase I–IV trials, including pilot and pivotal BE studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Technical Document Pre-Screening: Ensuring accuracy and compliance prior to submission</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Pharmacovigilance & Safety Monitoring
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Periodic Safety Update Reports (PSURs)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Pharmacovigilance System Master File (PSMF/DDPS)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Risk Management Plans (RMP)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Qualified Person for Pharmacovigilance (QPPV) Support</p>
        <p className="ml-2 mt-2 text-[#05326D]">Adverse Event (AE) & Serious Adverse Event (SAE) Reporting</p>
        <p className="ml-2 mt-2 text-[#05326D]">Adverse Drug Reaction (ADR) Management</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            EU-Specific Regulatory Support
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Readability/User Testing of Patient Information Leaflets (PIL)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Batch Release & Testing Coordination</p>
        <p className="ml-2 mt-2 text-[#05326D]">Certified Translations for Regulatory Submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Sourcing of Reference Listed Drugs (RLDs) & Reference Standards</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Proven expertise across regulated markets including EU, US, ASEAN, and RoW</p>
        <p className="ml-2 mt-2 text-[#05326D]">End-to-end project management from dossier development to post-submission support</p>
        <p className="ml-2 mt-2 text-[#05326D]">Cloud-based systems for secure, real-time collaboration</p>
        <p className="ml-2 mt-2 text-[#05326D]">Commitment to quality, compliance, and on-time delivery</p>
      </div>
    </div>
  );
}

export default RegulatorySupportServices;

